import type { MenuItemConfig } from '@/components/admin/menuConfig';
import { getArenaSlug } from '@/utils/arena';

export const RESERVED_ADMIN_ROUTES = [
  'booking',
  'transactions',
  'transaction',
  'field',
  'service',
  'other-product',
  'voucher',
  'profile-settings',
  'customers',
  'loyalty',
  'whatsapp',
  'wallet',
];

export function isReservedAdminRoute(segment?: string | null): boolean {
  if (!segment) return false;
  return RESERVED_ADMIN_ROUTES.includes(segment.toLowerCase());
}

export function getAdminBasePath(slug?: string | null): string {
  const candidate = slug && !isReservedAdminRoute(slug) ? slug : getArenaSlug();
  const safeSlug = candidate && !isReservedAdminRoute(candidate) ? candidate : null;
  return safeSlug ? `/admin/${safeSlug}` : '/admin';
}

export function prefixAdminPaths(items: MenuItemConfig[], slug?: string | null): MenuItemConfig[] {
  const safeSlug = slug && !isReservedAdminRoute(slug) ? slug : getArenaSlug();
  if (!safeSlug || isReservedAdminRoute(safeSlug)) return items;
  const base = getAdminBasePath(safeSlug);
  return items.map((item) => ({
    ...item,
    path: item.path.replace('/admin', base),
    children: item.children?.map((child) => ({
      ...child,
      path: child.path.replace('/admin', base),
    })),
  }));
}

